export const getContextsForTabs = (ctx: string, contextType?: string) => {
    if (contextType && ctx) {
      return `${contextType}/${ctx}`;
    }
    switch (ctx) {
      case 'startuphse':
        return 'startuphse'
      case 'main_books': 
        return 'main_books'
      case 'laboratory':
        return 'hselab'
      case 'illustration' :
        return 'hse-illustration'
      case 'collaborations' :
        return 'hsecolab'
      case 'gallery' :
        return 'hsegallery'
      case 'visualResearch' :
        return 'hsevisualresearch'
      case 'management':
        return 'hsemanagement'
      case 'startup':
      case 'hsestartup': 
       return 'hsemanagement'
      case 'books' :
        return 'hsebooks'
      case 'hsebooks':
        return 'hsebooks'
      case 'education' :
        return 'hsealumni'
      case 'ageytomesh':
        return 'ageytomesh'
      case 'design':
        return 'design_geo';
      case 'events':
        return 'events_geo';
      case 'creative':
        return 'creative_geo';
      case 'academy':
        return 'academy_geo';
      case 'places':
        return 'places_geo'
      case 'main_geo':
        return 'main_geo'
      case 'art':
        return 'art_geo'
      case 'CGLAB': 
        return 'hsecglab'
      case 'research':
        return 'research'
      case 'competitions': 
        return 'competitions'
      case 'sound':
        return 'sound'
      case 'pro':
        return 'hsepro'
      case 'lms':
        return 'lms'
      case 'lmshse':
        return 'lmshse'
      case 'hsepublishinghouse':
        return 'hsepublishinghouse'
      case 'hsevisualresearch':
        return 'hsevisualresearch'
      case 'hsesound':
        return 'hsesound'
      case 'hsedesign_main':
        return 'hsedesign_main'
      default:
        return '';
    }
  }export const getContextsForTabs = (ctx: string, contextType?: string) => {
    if (contextType && ctx) {
      return `${contextType}/${ctx}`;
    }
    switch (ctx) {
      case 'startuphse':
        return 'startuphse'
      case 'main_books': 
        return 'main_books'
      case 'laboratory':
        return 'hselab'
      case 'illustration' :
        return 'hse-illustration'
      case 'collaborations' :
        return 'hsecolab'
      case 'gallery' :
        return 'hsegallery'
      case 'visualResearch' :
        return 'hsevisualresearch'
      case 'management':
        return 'hsemanagement'
      case 'startup':
      case 'hsestartup': 
       return 'hsemanagement'
      case 'books' :
        return 'hsebooks'
      case 'hsebooks':
        return 'hsebooks'
      case 'education' :
        return 'hsealumni'
      case 'ageytomesh':
        return 'ageytomesh'
      case 'design':
        return 'design_geo';
      case 'events':
        return 'events_geo';
      case 'creative':
        return 'creative_geo';
      case 'academy':
        return 'academy_geo';
      case 'places':
        return 'places_geo'
      case 'main_geo':
        return 'main_geo'
      case 'art':
        return 'art_geo'
      case 'CGLAB': 
        return 'hsecglab'
      case 'research':
        return 'research'
      case 'competitions': 
        return 'competitions'
      case 'sound':
        return 'sound'
      case 'pro':
        return 'hsepro'
      case 'lms':
        return 'lms'
      case 'lmshse':
        return 'lmshse'
      case 'hsepublishinghouse':
        return 'hsepublishinghouse'
      case 'hsevisualresearch':
        return 'hsevisualresearch'
      case 'hsesound':
        return 'hsesound'
      case 'hsedesign_main':
        return 'hsedesign_main'
      default:
        return '';
    }
  }